module.exports = __webpack_public_path__ + "static/media/vag.6f4bf82f.mp3";